import { attachRedirectionOnUnauthorized, attachTokenCallback, setApiUrl } from '@gozoki/api'

// Clé de token dédiée à store-app, isolée du `bearerToken` du back-office
// (les deux apps peuvent cohabiter dans le même navigateur en dev).
const STORE_TOKEN_KEY = 'storeBearerToken'

export const getToken = async () => localStorage.getItem(STORE_TOKEN_KEY)

export const setToken = async (token: string | null) =>
  localStorage.setItem(STORE_TOKEN_KEY, token ?? '')

setApiUrl(import.meta.env.VITE_BACKEND_API_ENDPOINT)
attachTokenCallback(getToken)
attachRedirectionOnUnauthorized(() => {
  // Token expiré/invalide : on le purge et on recharge `/`, ce qui relance la résolution par IP.
  // Si l'IP n'est plus rattachée à une boutique, la garde de `/` redirigera vers `/error`.
  if (window.location.pathname.startsWith('/error')) return
  setToken(null)
  window.location.replace('/')
})
